import * as React from "react";
import PropTypes from "prop-types";
import {
  Eye16Filled,
  Certificate16Regular,
  ListBar16Filled,
  TableSimple16Regular,
  MoreHorizontal16Regular,
  Attach16Regular,
  MoreVertical16Filled,
} from "@fluentui/react-icons";
import {
  Label,
  Menu,
  MenuButton,
  MenuItem,
  MenuItemLink,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Tooltip,
  Image,
  Text,
  Link,
  tokens,
  makeStyles,
  Card,
  CardFooter,
  CardHeader,
  CardPreview,
  Button,
  typographyStyles,
} from "@fluentui/react-components";
const useStyles = makeStyles({
  component: {
    paddingRight: tokens.spacingHorizontalM,
  },
  tools: {
    marginBottom: tokens.spacingVerticalM,
    textAlign: "right",
  },
  cards: {
    marginBottom: tokens.spacingVerticalM,
  },
  card: {
    marginBottom: tokens.spacingVerticalM,
  },
  cardPreview: {
    paddingLeft: tokens.spacingVerticalM,
    paddingRight: tokens.spacingVerticalM,
  },
  toolsButton: {
    marginLeft: tokens.spacingHorizontalSNudge,
  },
  label: {
    display: "block",
    color: tokens.colorBrandStroke1,
    fontWeight: tokens.fontWeightBold,
  },
  text: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    marginRight: tokens.spacingHorizontalSNudge,
  },
  textBlock: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    display: "block",
  },
  textStrong: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightBold,
  },
  textLink: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
  },
  textLinkStrong: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightBold,
  },
  inline: {
    display: "inlineBlock",
  },
});

const Voicemail = (props) => {
  const { data, domain, loading } = props;
  const styles = useStyles();

  return (
    <section className={styles.component}>
      {loading == false ? (
        data && data.length ? (
          <div className={styles.cards}>
            {data.map((email) => {
              return (
                <Card className={styles.card} key={email.id}>
                  <CardHeader
                    header={<Link className={styles.textLinkStrong}>3CX</Link>}
                    action={
                      <div>
                        <Text className={styles.text}>{new Date(email.receivedDateTime.date).toLocaleString()}</Text>
                      </div>
                    }
                  />
                  <CardPreview className={styles.cardPreview}>
                    <Text className={email.isRead ? styles.text : styles.textStrong}>
                      {email.hasAttachments && <Attach16Regular />}
                      {email.subject}
                    </Text>
                  </CardPreview>
                  <CardFooter>
                    {email.hasAttachments &&
                      email.attachments.map((attachment) => {
                        const source = "data:" + attachment.contentType + ";base64," + attachment.contentBytes;
                        return (
                          <audio key={attachment.id} controls>
                            <source src={source} />
                          </audio>
                        );
                      })}
                  </CardFooter>
                </Card>
              );
            })}
          </div>
        ) : (
          <Text className={styles.text}>No email found</Text>
        )
      ) : (
        <Text>Loading...</Text>
      )}
    </section>
  );
};

Voicemail.propTypes = {
  query: PropTypes.object,
};

export default Voicemail;
